import React from "react";
import "./Gpmsdeployment.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const HEAD = {
  badge: "DEPLOYMENT",
  titleLine1: "Flexible Integration",
  titleLine2: "& Deployment",
  subtitle: "Designed Around Your Existing Infrastructure",
  intro:
    "GPMS is built to work with existing port applications and operational databases, reducing the need to replace established enterprise systems.",
  lead: "Depending on the client's infrastructure, licensing, and security requirements, the solution can be configured for:",
};

const MODELS = [
  {
    title: "On-Premises",
    tag: "Deployment",
    desc: "On-premises deployment within the client's own infrastructure.",
    icon: "server",
  },
  {
    title: "Cloud-Based",
    tag: "Deployment",
    desc: "Cloud-based deployment, configured to the client's requirements.",
    icon: "cloud",
  },
  {
    title: "Hybrid",
    tag: "Environments",
    desc: "Hybrid environments combining on-premises and cloud components.",
    icon: "globe",
  },
];

const FOOTNOTE =
  "Dashboard configurations, integrations, and AI module implementations can be adapted to each port's operational requirements and available data.";

/* ============================================================
   ICONS
   ============================================================ */
const ICONS = {
  server: (
    <>
      <rect x="2" y="2" width="20" height="8" rx="2" />
      <rect x="2" y="14" width="20" height="8" rx="2" />
      <path d="M6 6h.01M6 18h.01" />
    </>
  ),
  cloud: <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />,
  globe: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
      <path d="M2 12h20" />
    </>
  ),
  layers: (
    <>
      <path d="m12 2 10 5-10 5L2 7z" />
      <path d="m2 17 10 5 10-5" />
      <path d="m2 12 10 5 10-5" />
    </>
  ),
  activity: (
    <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2" />
  ),
};

const Icon = ({ name, size = 26 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICONS[name]}
  </svg>
);

/* ============================================================
   SECTION
   ============================================================ */
const GPMSDeployment = () => (
  <section className="gd">
    <div className="gd__container">
      {/* badge row */}
      <div className="gd__badge-row">
        <span className="gd__badge">
          <Icon name="server" size={14} /> {HEAD.badge}
        </span>
        <span className="gd__badge-line" />
      </div>

      {/* heading */}
      <header className="gd__head">
        <h2 className="gd__title">
          {HEAD.titleLine1}
          <span>{HEAD.titleLine2}</span>
        </h2>
        <p className="gd__subtitle">{HEAD.subtitle}</p>
        <p className="gd__intro">{HEAD.intro}</p>
      </header>

      {/* connector row */}
      <div className="gd__flow" aria-hidden="true">
        <span className="gd__flow-chip">Existing Port Systems</span>
        <span className="gd__dot" />
        <span className="gd__line" />
        <span className="gd__hub">
          <Icon name="layers" size={18} /> GPMS
        </span>
        <span className="gd__line" />
        <span className="gd__dot" />
        <span className="gd__flow-chip">Your Environment</span>
      </div>

      <p className="gd__lead">{HEAD.lead}</p>

      {/* cards */}
      <div className="gd__grid">
        {MODELS.map((m, i) => (
          <article className="gd__card" key={m.title}>
            <span className="gd__num" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>

            <div className="gd__card-top">
              <span className="gd__icon">
                <Icon name={m.icon} />
              </span>
              <div>
                <h3 className="gd__card-title">{m.title}</h3>
                <span className="gd__card-tag">{m.tag}</span>
              </div>
            </div>

            <p className="gd__card-desc">{m.desc}</p>

            <div className="gd__card-foot">
              <span className="gd__status">
                <i /> Configurable
              </span>
            </div>
          </article>
        ))}
      </div>

      {/* footnote bar */}
      <div className="gd__note">
        <span className="gd__note-icon">
          <Icon name="activity" size={20} />
        </span>
        <p>{FOOTNOTE}</p>
      </div>
    </div>
  </section>
);

export default GPMSDeployment;